import React from "react";
import { FaGithub, FaLinkedin, FaEnvelope, FaMapMarkerAlt, FaPhoneAlt } from "react-icons/fa";

export default function Contact() {
  return (
    <section id="contact" className="contact">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Get in Touch</h2>
          <p className="section-subtitle">
            Open to software engineering opportunities, infrastructure & cybersecurity roles, and technical collaborations.
          </p>
        </div>

        <div className="contact-grid">
          <div className="contact-card">
            <div>
              <div className="contact-card-head">
                <div className="contact-icon">
                  <FaEnvelope />
                </div>
                <div>
                  <h3>Direct Communication</h3>
                </div>
              </div>
              <a
                href="mailto:ayelgumhandson001@gmail.com"
                className="contact-email"
              >
                ayelgumhandson001@gmail.com
              </a>
              <p className="contact-note">
                Feel free to email me directly regarding full/part-time roles or system/app development projects. I aim to respond within 24–48 hours.
              </p>
            </div>

            <div style={{ marginTop: "20px", display: "flex", gap: "16px", flexWrap: "wrap", fontSize: "0.875rem", color: "var(--muted)" }}>
              <span style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}>
                <FaMapMarkerAlt color="var(--accent)" /> Accra, Ghana
              </span>
              <span style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}>
                <FaPhoneAlt color="var(--accent)" /> +233 59 930 9776
              </span>
            </div>
          </div>

          <aside className="contact-socials">
            <div>
              <h4>Connect & Profiles</h4>
              <p style={{ color: "var(--muted)", fontSize: "0.925rem", margin: "0 0 16px 0", lineHeight: "1.5" }}>
                Explore my open source repositories, architecture blueprints, or connect professionally.
              </p>
              <div className="social-links">
                <a
                  href="https://github.com/Handson-A"
                  target="_blank"
                  rel="noreferrer"
                  className="social-btn"
                  aria-label="GitHub Profile"
                >
                  <FaGithub />
                  <span>github.com/Handson-A</span>
                </a>
                <a
                  href="https://linkedin.com/in/ayelson"
                  target="_blank"
                  rel="noreferrer"
                  className="social-btn"
                  aria-label="LinkedIn Profile"
                >
                  <FaLinkedin />
                  <span>linkedin.com/in/ayelson</span>
                </a>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}
